module.exports = __webpack_public_path__ + "img/ascend_gold35.73cd1a05.png";